// extracted by mini-css-extract-plugin
export default {"center":"Text_center__v9o0L","pb":"Text_pb__GntSO","link":"Text_link__ry1bF"};